module.exports = "<div id=\"navigation\">\n  <ul side-navigation class=\"nav\" id=\"side-menu\">\n    <li ui-sref-active=\"active\">\n      <a ui-sref=\"admin.company-benefits\"> <span class=\"nav-label\">Company Benefits</span></a>\n    </li>\n    <li ui-sref-active=\"active\">\n      <a ui-sref=\"analytics\"> <span class=\"nav-label\">Analytics</span></a>\n    </li>\n  </ul>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/settings-sidebar/settings-sidebar.html
// module id = 601
// module chunks = 0